import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import { RouteGuard } from '@core/components/navigation/RouteGuard';
import GeneralLayout from '@core/layouts/GeneralLayout';
import { ROUTES } from '@core/utils/constants';

const Auth = lazy(() => import('@auth/ui/pages/Auth'));
const ResetPassword = lazy(() => import('@auth/ui/pages/ResetPassword'));
const AcceptInvitation = lazy(() => import('@auth/ui/pages/AcceptInvitation'));

const AuthRouter: RouteObject = {
  element: (
    <RouteGuard mode="public">
      <GeneralLayout />
    </RouteGuard>
  ),
  children: [
    { path: ROUTES.auth.login, element: <Auth initialForm="login" /> },
    { path: ROUTES.auth.register, element: <Auth initialForm="register" /> },
    { path: ROUTES.auth.forgotPassword, element: <Auth initialForm="forgotPassword" /> },
    { path: ROUTES.auth.resetPassword, element: <ResetPassword /> },
    { path: ROUTES.auth.acceptInvitation, element: <AcceptInvitation /> },
  ],
};

export default AuthRouter;
